module.exports = __webpack_public_path__ + "static/img/valoraciones.ea4833dc.jpg";